import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { requestOTP } from '../services/user';

const RequestOTP = (props) => {
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [referrer, setReferrer] = useState(null);

  useEffect(() => {
    document.title = 'EQS CLUB - Ingresá a tu cuenta';
  }, []);

  useEffect(() => {
    // Get referrer
    if (!props.location.search || props.location.search === '') {
      return;
    }

    const params = props.location.search.replaceAll('?', '&').split('&');
    params.forEach(item => {
      const a = item.split('=');
      if (a[0] === 'ref') {
        setReferrer(a[1]);
      }
    });

  }, [props.location.search]);

  const handleSubmit = async () => {
    if (!email) {
      setError('Por favor, ingresá un email válido.');
    }

    try {
      const res = await requestOTP(email);
      if (!res.success) {
        throw new Error(res.error || 'Error al enviar código OTP');
      }
      props.history.push('/ingresa-otp', { email });
    } catch (e) {
      let msj = 'Error al enviar código OTP';
      if (e.error === 'User not found') {
        msj = 'El email ingresado no corresponde a un usuario activo.';
      }
      setError(msj);
    }
  };

  return (
    <div className="signup-template">
      <div className="row g-0 align-items-center">
        <div className="col-lg-7 bg-black">
          {
            props.assets.signin_cover_web && <img src={props.assets.signin_cover_web} className="cover-fit" alt="Sign in Cover" />
          }
        </div>
        <div className="col-lg-5 px-md-3 px-xl-5">
          <div className="px-3 py-4 p-md-5 p-xxl-5 mx-xxl-4">
            <div className="login-form py-2 py-md-0 mx-auto mx-lg-0">
              <h2 className="h1 mb-3">Ingresá con código</h2>
              <div className="">
                <label className="form-label form-label-lg" htmlFor="email">Ingresá tu email</label>
                <input type="email" className="form-control form-control-xl" id="email" placeholder="Email" value={email} onChange={({ target }) => setEmail(target.value)} />
                <p className="text-danger fw-bold">{error}</p>
              </div>
              <div className="border-top border-gray-200 my-5 text-center text-decoration-underline">
                <a
                  href={"mailto:" + process.env.REACT_APP_SUPPORT_EMAIL}
                  className="text-gray-700"
                  style={{ cursor: 'pointer' }}>Tengo un problema</a>
              </div>
              <div className="d-grid">
                <button onClick={handleSubmit} className="btn btn-xl btn-primary text-white">Enviar código</button>
              </div>
              <div className="d-grid">
                <NavLink to="/ingresa" className="d-grid">
                  <button  className="mt-3 btn btn-xl btn-outline-success">Volver</button>
                </NavLink>
              </div>
              <div className="border-top border-gray-200 pt-4">
                <span className="text-gray-700">¿No tenés cuenta? <NavLink to={`/registrate${referrer ? `?ref=${referrer}` : ''}`} className="link-primary">Registrate</NavLink></span>
              </div>
            </div>
            <div className="position-absolute py-3">
              <small className="text-gray-600 mb-2">Desarrollado por <a href="https://www.reachout.global/" target="_blank" rel="noreferrer" className="text-black fw-bold">ReachOut</a> &mdash; Versión {process.env.REACT_APP_VERSION}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth.isAuthenticated,
  assets: state.assets,
});

export default connect(mapStateToProps)(RequestOTP);
